import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import ImageDownload from '../ImageDownload';
import DataDownload from '../DataDownload';
import NoResult from '../NoResult';

import './ViolinPlotResults.css';

const apiHost = process.env.REACT_APP_API_HOST;
const apiProto = process.env.REACT_APP_API_PROTOCOL;

class ViolinPlotResults extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchParameters: {},
    };
  }

  componentDidMount() {
    this.updateSearchParams();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.hash !== prevProps.match.params.hash) {
      this.updateSearchParams();
    }
  }

  updateSearchParams() {
    const { match } = this.props;
    const id = match.params.hash;
    const searchUrl = `${apiProto}://${apiHost}/search/${id}`;
    axios.get(searchUrl).then((response) => {
      this.setState({ searchParameters: response.data });
    });
  }

  render() {
    const { match } = this.props;
    const { searchParameters } = this.state;
    const id = match.params.hash;

    // use the id to fetch the search parameters.
    // also use it to place the result image in the page
    // as returned by the api.
    // const plotUrl = `/api/nuclei/barplot/image/${id}`;
    const plotUrl = `${apiProto}://${apiHost}/single-cell/violinplot/image/${id}`;
    const dataUrl = `${apiProto}://${apiHost}/single-cell/violinplot/data/${id}`;

    if (searchParameters.genes && searchParameters.genes.length < 1) {
      return <NoResult />;
    }

    return (
      <div className="row violinplot-results">
        <div className="col">
          <div className="card">
            <div className="card-header">
              Results
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col">
                  <h3>Parameters</h3>
                  <dl>
                    {searchParameters.gene && ([
                      <dt key="label">Gene</dt>,
                      <dd key="value">{searchParameters.gene}</dd>,
                    ])}
                    <dt key="label">Log scale</dt>
                    <dd key="value">{
                      (searchParameters.logScale)
                        ? 'True'
                        : 'False'
                    }
                    </dd>
                  </dl>
                </div>
              </div>
              <div className="row">
                <div className="col-lg">
                  <img alt="Violin Plot of Results. Download below to get raw text data." src={plotUrl} />
                </div>
              </div>
              <div className="row">
                <div className="col-lg">
                  <ImageDownload id={id} plotUrl={plotUrl} />
                  <DataDownload id={id} dataUrl={dataUrl} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ViolinPlotResults.propTypes = {
  match: PropTypes.object.isRequired,
};

export default ViolinPlotResults;



// WEBPACK FOOTER //
// ./src/components/SingleCell/ViolinPlotResults.jsx